import styled from 'styled-components';

import CommonGoogleAdsBanner from '~components/GoogleAdsBanner';

export const GoogleAdsBanner = styled(CommonGoogleAdsBanner)`
  margin: 15px 0 15px -38px;

  ${({ theme }) => theme.media.tablet} {
    margin: 15px auto;
  }

  ${({ theme }) => theme.media.mobile} {
    margin: 15px auto;
  }
`;

export const Title = styled.h2`
  display: block;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.H4};
  margin: 0;
  padding: 0;
  font-size: ${(props) => props.theme.fontSize.H4};
  text-align: left;
  flex: 1;
`;

export const UpdateDateWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;

  ${({ theme }) => theme.media.pc} {
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 0;
  }
`;

export const UpdateDate = styled.span`
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-size: ${(props) => props.theme.fontSize.B3};
  color: ${(props) => props.theme.colors.gray700};
  display: flex;
  align-items: center;
  height: 25px;
  padding: 0 4px;
  background: ${({ theme }) => theme.colors.gray300};
  border-radius: 4px;

  & svg {
    margin-left: 7px;
  }
`;

export const RankingCardGroup = styled.div`
  border: 1px solid #ebebeb;
  border-radius: 4px;
`;

export const RankingBody = styled.section`
  margin-top: 20px;
`;

export const ShowMore = styled.a`
  display: inline-block;
  background: ${({ theme }) => theme.colors.white100};
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  box-sizing: border-box;
  border-radius: 100px;

  font-size: ${({ theme }) => theme.fontSize.B2};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.gray800};
  padding: 14px 40px;
`;

export const RankingWrapper = styled.main`
  position: relative;
  width: 652px;
  margin: 10px auto 0;
  min-height: 300px;

  & > ${ShowMore} {
    margin-top: 30px;
  }

  ${({ theme }) => theme.media.with('tablet', 'mobile')} {
    width: 100%;
    margin-top: 0;
  }
`;
